// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e0fea7a3","container":"b74d8ac4","textContainer":"fa9f8b60","leftContent":"c788dd89","rightContent":"ec69d0e8"};